export var extractEvent = function (event) {
    var data = {};
    for (var i in event) {
        if (!event.hasOwnProperty(i))
            continue;
        if (typeof event[i] == 'object' && event[i] !== null) {
            var flatObject = extractEvent(event[i]);
            for (var x in flatObject) {
                if (!flatObject.hasOwnProperty(x))
                    continue;
                data[i + '.' + x] = flatObject[x];
            }
        }
        else {
            data[i] = event[i];
        }
    }
    return data;
};
